import { createAction, createAsyncAction } from "typesafe-actions";

import type {
    ExcludeAccountFields,
    ExcludeStatusFields,
    SalesforceMappingField,
} from "app/pages/sales-intelligence/common-components/export-table/types";
import type { FetchError } from "app/pages/sales-intelligence/types";

import type { IntegrationStatusResponse } from "../../components/types";
import type { CrmFeedLevel, CRMListObjectsType, IntegrationSyncStatus } from "../../types";
import type { SalesforceColumns } from "../type";

export const getSalesforceStatusAsync = createAsyncAction(
    "@@si/management/salesforce-integration/GET_STATUS_START",
    "@@si/management/salesforce-integration/GET_STATUS_SUCCESS",
    "@@si/management/salesforce-integration/GET_STATUS_FAILURE",
)<boolean, IntegrationStatusResponse, FetchError>();

export const getExcludeStatusFieldsAsync = createAsyncAction(
    "@@si/management/salesforce-integration/GET_EXCLUDE_STATUS_FIELDS_START",
    "@@si/management/salesforce-integration/GET_EXCLUDE_STATUS_FIELDS_SUCCESS",
    "@@si/management/salesforce-integration/GET_EXCLUDE_STATUS_FIELDS_FAILURE",
)<void, ExcludeStatusFields, FetchError>();

export const getSfContactsFieldsAsync = createAsyncAction(
    "@@si/management/salesforce-integration/GET_CONTACTS_FIELDS_START",
    "@@si/management/salesforce-integration/GET_CONTACTS_FIELDS_SUCCESS",
    "@@si/management/salesforce-integration/GET_CONTACTS_FIELDS_FAILURE",
)<void, string[], FetchError>();

export const getSfLeadsFieldsAsync = createAsyncAction(
    "@@si/management/salesforce-integration/GET_LEADS_FIELDS_START",
    "@@si/management/salesforce-integration/GET_LEADS_FIELDS_SUCCESS",
    "@@si/management/salesforce-integration/GET_LEADS_FIELDS_FAILURE",
)<void, string[], FetchError>();

export const getExcludeAccountFieldsAsync = createAsyncAction(
    "@@si/management/salesforce-integration/GET_EXCLUDE_ACCOUNT_FIELDS_START",
    "@@si/management/salesforce-integration/GET_EXCLUDE_ACCOUNT_FIELDS_SUCCESS",
    "@@si/management/salesforce-integration/GET_EXCLUDE_ACCOUNT_FIELDS_FAILURE",
)<void, ExcludeAccountFields, FetchError>();

export const getMappingFieldsAsync = createAsyncAction(
    "@@si/management/salesforce-integration/GET_MAPPING_FIELDS_START",
    "@@si/management/salesforce-integration/GET_MAPPING_FIELDS_SUCCESS",
    "@@si/management/salesforce-integration/GET_MAPPING_FIELDS_FAILURE",
)<void, SalesforceMappingField[], FetchError>();

export const putStatusFieldAsync = createAsyncAction(
    "@@si/management/salesforce-integration/PUT_STATUS_FIELD_START",
    "@@si/management/salesforce-integration/PUT_STATUS_FIELD_SUCCESS",
    "@@si/management/salesforce-integration/PUT_STATUS_FIELD_FAILURE",
)<void, void, FetchError>();

export const putIntegrationLeadFilterStatusAsync = createAsyncAction(
    "@@si/management/salesforce-integration/PUT_INTEGRATION_LEAD_FILTER_STATUS_FIELDS_START",
    "@@si/management/salesforce-integration/PUT_INTEGRATION_LEAD_FILTER_STATUS_FIELDS_SUCCESS",
    "@@si/management/salesforce-integration/PUT_INTEGRATION_LEAD_FILTER_STATUS_FIELDS_FAILURE",
)<void, boolean, FetchError>();

export const getIntegrationLeadFilterStatusAsync = createAsyncAction(
    "@@si/management/salesforce-integration/GET_INTEGRATION_LEAD_FILTER_STATUS_FIELDS_START",
    "@@si/management/salesforce-integration/GET_INTEGRATION_LEAD_FILTER_STATUS_FIELDS_SUCCESS",
    "@@si/management/salesforce-integration/GET_INTEGRATION_LEAD_FILTER_STATUS_FIELDS_FAILURE",
)<void, boolean, FetchError>();

export const putFilterFieldsAsync = createAsyncAction(
    "@@si/management/salesforce-integration/PUT_FILTER_FIELDS_START",
    "@@si/management/salesforce-integration/PUT_FILTER_FIELDS_SUCCESS",
    "@@si/management/salesforce-integration/PUT_FILTER_FIELDS_FAILURE",
)<void, boolean, FetchError>();

export const disconnectSalesforceAsync = createAsyncAction(
    "@@si/management/salesforce-integration/DISCONNECT_SALESFORCE_START",
    "@@si/management/salesforce-integration/DISCONNECT_SALESFORCE_SUCCESS",
    "@@si/management/salesforce-integration/DISCONNECT_SALESFORCE_FAILURE",
)<void, void, FetchError>();

export const setSyncStatus = createAction(
    "@@si/management/salesforce-integration/SET_STATUS_MANUALLY",
)<IntegrationSyncStatus>();

export const setIsSfAccountsExportEnabled = createAction(
    "@@si/management/salesforce-integration/SET_IS_SF_ACCOUNTS_EXPORT_ENABLED",
)<boolean>();

export const setIsSfContactsExportEnabled = createAction(
    "@@si/management/salesforce-integration/SET_IS_SF_CONTACTS_EXPORT_ENABLED",
)<boolean>();

export const setIsSfLeadsExportEnabled = createAction(
    "@@si/management/salesforce-integration/SET_IS_SF_LEADS_EXPORT_ENABLED",
)<boolean>();

export const getSfColumnsAsync = createAsyncAction(
    "@@si/management/salesforce-integration/GET_COLUMNS_START",
    "@@si/management/salesforce-integration/GET_COLUMNS_SUCCESS",
    "@@si/management/salesforce-integration/GET_COLUMNS_FAILURE",
)<void, SalesforceColumns, FetchError>();

export const setIsSfCrmLabelEnabled = createAction(
    "@@si/management/salesforce/manage-integrations/SET_IS_SF_CRM_LABEL_ENABLED",
)<boolean>();

export const setIsSfFeedEnabled = createAction(
    "@@si/management/salesforce/manage-integrations/SET_IS_SF_FEED_ENABLED",
)<boolean>();

export const setIsSfCrmListEnabled = createAction(
    "@@si/management/salesforce/manage-integrations/SET_IS_SF_CRM_LIST_ENABLED",
)<boolean>();

export const setSfCrmListObjectsType = createAction(
    "@@si/management/salesforce/manage-integrations/SET_SF_CRM_LIST_OBJECTS_TYPE",
)<CRMListObjectsType>();

export const setSfCrmFeedLevel = createAction(
    "@@si/management/salesforce/manage-integrations/SET_SF_CRM_FEED_LEVEL",
)<CrmFeedLevel>();
